import React from 'react'
import ReactDOM from 'react-dom/client'
import { AuthProvider } from 'react-oidc-context'
import { AppRouter } from './app/AppRouter'
import { ThemeProvider } from './theme/ThemeProvider'
import { AccentProvider } from './theme/AccentProvider'
import { oidcUserManager } from './auth/oidcUserManager'
import './styles/tokens.css'
import './styles/controls.css'

const root = document.getElementById('root')
if (!root) {
  throw new Error('#root is missing from index.html')
}

/**
 * ADR-0048 (Phase A, #7): strips the `code`/`state`/`session_state`/`iss` query params the
 * Authorization Code redirect lands with, once `react-oidc-context` has consumed them — the browser
 * URL bar (and `BrowserRouter`'s own location) should never keep a one-time authorization code
 * visible/bookmarkable after the exchange completes.
 */
function onSigninCallback(): void {
  window.history.replaceState({}, document.title, window.location.pathname)
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <AuthProvider userManager={oidcUserManager} onSigninCallback={onSigninCallback}>
      <ThemeProvider>
        <AccentProvider>
          <AppRouter />
        </AccentProvider>
      </ThemeProvider>
    </AuthProvider>
  </React.StrictMode>,
)
